import Icon from '@components/v2/ui/Icon/Icon';
import { CirclePlay } from 'lucide-react';
import useWidth from '../../../../../../components/Hooks/useWidth';
import { ProductMedia } from '../../../../ProductTypes';
import { getFocusZoomPercentToScroll } from '../../utils/getFocusZoomPercentToScroll';
import { useThumbMediaV2Styles } from './galleryThumbStrip.styles';

interface ThumbMediaV2Props {
  media: ProductMedia;
  mediaUrl: string;
  onZoom?: (media: ProductMedia, focusPercentToScroll?: number) => void;
}

const ThumbMediaV2 = ({ media, mediaUrl, onZoom }: ThumbMediaV2Props) => {
  const { mediumDownWidth } = useWidth();
  const { classes } = useThumbMediaV2Styles();

  const handleClickMedia = (event?: React.MouseEvent<HTMLDivElement>) => {
    if (!mediumDownWidth || !onZoom) {
      return;
    }

    onZoom(media, getFocusZoomPercentToScroll(event));
  };

  if (media.type !== 'IMAGE') {
    return (
      <>
        <Icon icon={CirclePlay} size="lg" className={classes.playIcon} />
        <video
          src={`${mediaUrl}#t=.05`}
          className={classes.media}
          autoPlay
          muted
          disablePictureInPicture
        />
      </>
    );
  }

  return (
    <div
      role="button"
      tabIndex={-1}
      className={classes.mediaWrapper}
      onClick={handleClickMedia}
      onKeyDown={(event) => event.key === 'Enter' && handleClickMedia()}
    >
      <img src={mediaUrl} alt="thumbnail" className={classes.media} />
    </div>
  );
};

export default ThumbMediaV2;
